import TpJobAdmin from './TpJobAdmin';

export default class UninvoiceableTpJobAdmin extends TpJobAdmin {}
